import Vue from "vue";

export async function fetchMenu({ commit }, title) {
  try {
    const { data } = await Vue.axios({
      url: "/frontend/menus", params: { title }
    });
    commit("menus/setMenu", data, {
      root: true
    });
  } catch (e) {
    commit("menus/menuError", e.message, {
      root: true
    });
  } finally {
    // console.log("La petición para obtener menus ha finalizado");
  }
}

export async function fetchMenuMobile({ commit }, full_legal_number) {
  try { 
    const { data } = await Vue.axios({
      url: `/frontend/api_menu_mobile?view_as=${full_legal_number}`
      // url: `/frontend/api_menu_mobile`
    });
    commit("menus/setMenus", data, {
      root: true
    });
  } catch (error) {
    commit("menus/menuError", e.message, {
      root: true
    });
  } finally {}
}

export async function fetchPersonalBanking({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/menus/personal_banking?view_as=${full_legal_number}`
    });
    commit("menus/setPersonalBankingMenus", data, { root: true });
    return data;
  } catch (e) {
    console.error(e);
  }
}